import React from 'react';

import { LinkButton, StandardButton } from '@eika/button';
import { WarningCard } from '@eika/card';

import type { PaymentType } from '../../generated-types';
import useTranslation from '../../hooks/useTranslation';
import { useSigningContext } from '../../signingContext/signingContext';
import { Actions } from '../../signingContext/signingTypes';

import './TransactionModal.scss';
import './TransactionResultInfo.scss';

export interface Props {
    onClose: () => void;
    paymentType: PaymentType;
}

const UpdateFuturePaymentRetry: React.FC<Props> = ({ onClose, paymentType }) => {
    const translated = useTranslation();
    const { dispatch, handleCancelSigningFlow } = useSigningContext();

    const notSignedMessage = translated.updateFuturePaymentInfoMessages[paymentType]?.notSigned;

    const cancelOperation = () => {
        dispatch({ type: Actions.RESET });
        onClose();
    };

    const onRetry = () => {
        dispatch({ type: Actions.UPDATE_STATUS, status: 'CREATED' });
    };

    const onEdit = () => {
        handleCancelSigningFlow();
    };

    return (
        <div className="centered-modal-content">
            <WarningCard title={notSignedMessage?.heading || ''} isModal>
                <p>{notSignedMessage?.description}</p>
                <div className="transaction-result-info__warning-button-row">
                    <div className="transaction-result-info__first-row">
                        <StandardButton
                            className="transaction-result-info__change-btn"
                            buttonType="negative"
                            onClick={onEdit}
                        >
                            {notSignedMessage?.change}
                        </StandardButton>
                        <StandardButton className="transaction-result-info__retry-btn" onClick={onRetry}>
                            {notSignedMessage?.tryAgain}
                        </StandardButton>
                    </div>
                    <LinkButton onClick={cancelOperation}>{notSignedMessage?.cancel}</LinkButton>
                </div>
            </WarningCard>
        </div>
    );
};

export default UpdateFuturePaymentRetry;
